/* istanbul ignore file */
import { IS_CLIENT } from 'src/settings';

export const logError = (message: Error | string, context?: Record<string, unknown>) => {
  const error = message instanceof Error ? message : new Error(message);

  if (IS_CLIENT && window.DD_RUM && window.DD_RUM.addError) {
    window.DD_RUM.addError(error, context, 'custom');
  } else {
    console.error(error.message, context);
  }
};
